// commonHRriskdata.js

// Hiring Risks (10 records)
const hiringRiskData = [
  {
    industry: "Common",
    department: "HR",
    riskId: "HR-HIR-001",
    riskDescription: "Delay in filling key positions due to lengthy recruitment process - Issue 1",
    riskCause: ["Inefficient screening", "Limited candidate pool"],
    consequence: "Critical roles remain vacant, affecting business productivity.",
    riskCategory: "Operational",
    processControlId: "CTRL-HIR-001",
    processControlDescription: "Implement a streamlined recruitment process with automated candidate tracking.",
    processControlDesign: "automated",
    typeOfProcessControl: "Preventive",
    processControlCategory: "Operational",
    frequency: "Monthly",
    processControlOwner: "HR Manager",
    expectedDeviations: ["Delayed candidate response", "Screening bottlenecks"],
    auditTestingProcedures: ["Review recruitment timelines", "Assess candidate tracking system"]
  },
  {
    industry: "Common",
    department: "HR",
    riskId: "HR-HIR-002",
    riskDescription: "Inaccurate candidate evaluation leading to poor hires - Issue 2",
    riskCause: ["Subjective interview process", "Lack of standardized evaluation criteria"],
    consequence: "Unsuitable hires may lower team performance and increase turnover.",
    riskCategory: "Operational",
    processControlId: "CTRL-HIR-002",
    processControlDescription: "Standardize candidate evaluations using structured interviews and scoring systems.",
    processControlDesign: "manual",
    typeOfProcessControl: "Detective",
    processControlCategory: "Operational",
    frequency: "Per hiring cycle",
    processControlOwner: "HR Manager",
    expectedDeviations: ["Inconsistent candidate ratings", "Evaluator bias"],
    auditTestingProcedures: ["Review interview records", "Audit candidate scorecards"]
  },
  {
    industry: "Common",
    department: "HR",
    riskId: "HR-HIR-003",
    riskDescription: "High recruitment costs due to inefficient sourcing channels - Issue 3",
    riskCause: ["Overreliance on expensive recruitment agencies", "Ineffective job postings"],
    consequence: "Budget overruns and reduced ROI on recruitment spend.",
    riskCategory: "Financial",
    processControlId: "CTRL-HIR-003",
    processControlDescription: "Optimize sourcing channels and implement cost-effective recruitment strategies.",
    processControlDesign: "system dependent",
    typeOfProcessControl: "Preventive",
    processControlCategory: "Financial",
    frequency: "Quarterly",
    processControlOwner: "HR Manager",
    expectedDeviations: ["Excessive agency fees", "Low application rates"],
    auditTestingProcedures: ["Analyze recruitment cost reports", "Benchmark sourcing strategies"]
  },
  {
    industry: "Common",
    department: "HR",
    riskId: "HR-HIR-004",
    riskDescription: "Candidate drop-off during the interview process due to slow communication - Issue 4",
    riskCause: ["Delayed feedback", "Inefficient scheduling"],
    consequence: "Loss of top candidates and prolonged vacancy durations.",
    riskCategory: "Operational",
    processControlId: "CTRL-HIR-004",
    processControlDescription: "Enhance communication protocols and streamline interview scheduling.",
    processControlDesign: "automated",
    typeOfProcessControl: "Preventive",
    processControlCategory: "Operational",
    frequency: "Per hiring cycle",
    processControlOwner: "HR Manager",
    expectedDeviations: ["Missed candidate follow-ups", "Scheduling delays"],
    auditTestingProcedures: ["Review communication logs", "Monitor scheduling efficiency"]
  },
  {
    industry: "Common",
    department: "HR",
    riskId: "HR-HIR-005",
    riskDescription: "Inadequate background screening leading to unsuitable hires - Issue 5",
    riskCause: ["Limited verification process", "Incomplete candidate information"],
    consequence: "Hiring individuals with undisclosed issues that may affect company culture.",
    riskCategory: "Operational",
    processControlId: "CTRL-HIR-005",
    processControlDescription: "Implement rigorous background and reference checks using third-party services.",
    processControlDesign: "system dependent",
    typeOfProcessControl: "Preventive",
    processControlCategory: "Operational",
    frequency: "Per hire",
    processControlOwner: "HR Manager",
    expectedDeviations: ["Incomplete screening", "Overlooked discrepancies"],
    auditTestingProcedures: ["Audit background check reports", "Verify reference outcomes"]
  },
  {
    industry: "Common",
    department: "HR",
    riskId: "HR-HIR-006",
    riskDescription: "Unclear job descriptions causing mismatched candidate expectations - Issue 6",
    riskCause: ["Vague role definitions", "Poor communication of job requirements"],
    consequence: "High turnover and job dissatisfaction due to role misalignment.",
    riskCategory: "Operational",
    processControlId: "CTRL-HIR-006",
    processControlDescription: "Develop clear, detailed job descriptions and ensure alignment with departmental needs.",
    processControlDesign: "manual",
    typeOfProcessControl: "Preventive",
    processControlCategory: "Operational",
    frequency: "Annually",
    processControlOwner: "HR Manager",
    expectedDeviations: ["Ambiguous role expectations", "Mismatch in candidate skills"],
    auditTestingProcedures: ["Review job description accuracy", "Survey new hire satisfaction"]
  },
  {
    industry: "Common",
    department: "HR",
    riskId: "HR-HIR-007",
    riskDescription: "Internal bias affecting candidate selection and reducing diversity - Issue 7",
    riskCause: ["Subjective decision-making", "Lack of standardized criteria"],
    consequence: "Reduced workplace diversity and potential legal issues.",
    riskCategory: "Operational",
    processControlId: "CTRL-HIR-007",
    processControlDescription: "Introduce blind recruitment practices and standardized evaluation forms.",
    processControlDesign: "manual",
    typeOfProcessControl: "Detective",
    processControlCategory: "Operational",
    frequency: "Per hiring cycle",
    processControlOwner: "HR Manager",
    expectedDeviations: ["Evaluator bias", "Inconsistent hiring practices"],
    auditTestingProcedures: ["Review hiring data for diversity", "Conduct bias training assessments"]
  },
  {
    industry: "Common",
    department: "HR",
    riskId: "HR-HIR-008",
    riskDescription: "Extended decision-making delaying final job offers - Issue 8",
    riskCause: ["Inefficient approval processes", "Multiple decision layers"],
    consequence: "Losing top candidates to competitors due to slow offers.",
    riskCategory: "Operational",
    processControlId: "CTRL-HIR-008",
    processControlDescription: "Streamline decision-making with clear delegation and defined timelines.",
    processControlDesign: "automated",
    typeOfProcessControl: "Preventive",
    processControlCategory: "Operational",
    frequency: "Per hiring cycle",
    processControlOwner: "HR Manager",
    expectedDeviations: ["Delayed approvals", "Candidate drop-off"],
    auditTestingProcedures: ["Review offer timelines", "Audit decision process efficiency"]
  },
  {
    industry: "Common",
    department: "HR",
    riskId: "HR-HIR-009",
    riskDescription: "Overdependence on employee referrals limiting candidate diversity - Issue 9",
    riskCause: ["Reliance on referral programs", "Limited external sourcing"],
    consequence: "Homogeneous workforce and reduced innovation.",
    riskCategory: "Strategic",
    processControlId: "CTRL-HIR-009",
    processControlDescription: "Diversify sourcing channels and set referral quotas.",
    processControlDesign: "manual",
    typeOfProcessControl: "Preventive",
    processControlCategory: "Strategic",
    frequency: "Quarterly",
    processControlOwner: "HR Manager",
    expectedDeviations: ["Referral overuse", "Lack of external applicants"],
    auditTestingProcedures: ["Review recruitment source data", "Assess candidate diversity metrics"]
  },
  {
    industry: "Common",
    department: "HR",
    riskId: "HR-HIR-010",
    riskDescription: "Ineffective recruitment marketing resulting in low application rates - Issue 10",
    riskCause: ["Outdated marketing channels", "Poor employer branding"],
    consequence: "Insufficient candidate pool and prolonged vacancies.",
    riskCategory: "Operational",
    processControlId: "CTRL-HIR-010",
    processControlDescription: "Revamp employer branding and leverage modern recruitment marketing strategies.",
    processControlDesign: "system dependent",
    typeOfProcessControl: "Preventive",
    processControlCategory: "Operational",
    frequency: "Annually",
    processControlOwner: "HR Manager",
    expectedDeviations: ["Low applicant volume", "Poor engagement metrics"],
    auditTestingProcedures: ["Analyze application rates", "Review marketing campaign performance"]
  }
];

// Termination Risks (10 records)
const terminationRiskData = [
  {
    industry: "Common",
    department: "HR",
    riskId: "HR-TER-001",
    riskDescription: "Delayed termination process increasing legal exposure - Issue 1",
    riskCause: ["Inefficient procedures", "Lack of timely documentation"],
    consequence: "Prolonged exposure to legal risks and potential lawsuits.",
    riskCategory: "Compliance",
    processControlId: "CTRL-TER-001",
    processControlDescription: "Implement clear termination protocols with strict timelines.",
    processControlDesign: "manual",
    typeOfProcessControl: "Preventive",
    processControlCategory: "Compliance",
    frequency: "Per termination",
    processControlOwner: "HR Manager",
    expectedDeviations: ["Process delays", "Incomplete documentation"],
    auditTestingProcedures: ["Review termination timelines", "Audit termination files"]
  },
  {
    industry: "Common",
    department: "HR",
    riskId: "HR-TER-002",
    riskDescription: "Inadequate documentation of terminations leading to disputes - Issue 2",
    riskCause: ["Poor record-keeping", "Lack of standard forms"],
    consequence: "Increased risk of litigation and employee disputes.",
    riskCategory: "Compliance",
    processControlId: "CTRL-TER-002",
    processControlDescription: "Standardize termination documentation and maintain secure records.",
    processControlDesign: "automated",
    typeOfProcessControl: "Detective",
    processControlCategory: "Compliance",
    frequency: "Per termination",
    processControlOwner: "HR Manager",
    expectedDeviations: ["Missing documents", "Inconsistent records"],
    auditTestingProcedures: ["Audit termination files", "Review HR records"]
  },
  {
    industry: "Common",
    department: "HR",
    riskId: "HR-TER-003",
    riskDescription: "Poor exit interview process missing key improvement opportunities - Issue 3",
    riskCause: ["Ineffective interview techniques", "Lack of structured format"],
    consequence: "Loss of actionable feedback to improve HR processes.",
    riskCategory: "Operational",
    processControlId: "CTRL-TER-003",
    processControlDescription: "Establish structured exit interviews with standardized questionnaires.",
    processControlDesign: "manual",
    typeOfProcessControl: "Detective",
    processControlCategory: "Operational",
    frequency: "Per termination",
    processControlOwner: "HR Manager",
    expectedDeviations: ["Inconsistent feedback", "Low participation"],
    auditTestingProcedures: ["Review exit interview records", "Analyze feedback data"]
  },
  {
    industry: "Common",
    department: "HR",
    riskId: "HR-TER-004",
    riskDescription: "Inconsistent application of termination policies leading to unfair practices - Issue 4",
    riskCause: ["Lack of standardized guidelines", "Manager discretion"],
    consequence: "Potential legal challenges and internal dissatisfaction.",
    riskCategory: "Compliance",
    processControlId: "CTRL-TER-004",
    processControlDescription: "Enforce standardized termination policies with regular training.",
    processControlDesign: "manual",
    typeOfProcessControl: "Preventive",
    processControlCategory: "Compliance",
    frequency: "Annually",
    processControlOwner: "HR Manager",
    expectedDeviations: ["Policy deviations", "Inconsistent treatment"],
    auditTestingProcedures: ["Audit termination decisions", "Review policy adherence"]
  },
  {
    industry: "Common",
    department: "HR",
    riskId: "HR-TER-005",
    riskDescription: "Inaccurate severance calculations leading to financial liabilities - Issue 5",
    riskCause: ["Manual calculations", "Lack of updated compensation data"],
    consequence: "Overpayment or underpayment risks resulting in disputes or liabilities.",
    riskCategory: "Financial",
    processControlId: "CTRL-TER-005",
    processControlDescription: "Automate severance calculations using updated HR systems.",
    processControlDesign: "automated",
    typeOfProcessControl: "Preventive",
    processControlCategory: "Financial",
    frequency: "Per termination",
    processControlOwner: "Payroll Manager",
    expectedDeviations: ["Calculation errors", "Delayed payments"],
    auditTestingProcedures: ["Review severance reports", "Test calculation modules"]
  },
  {
    industry: "Common",
    department: "HR",
    riskId: "HR-TER-006",
    riskDescription: "Failure to recover company property post-termination - Issue 6",
    riskCause: ["Inefficient exit procedures", "Lack of property tracking"],
    consequence: "Loss of company assets and potential security risks.",
    riskCategory: "Operational",
    processControlId: "CTRL-TER-006",
    processControlDescription: "Implement an exit checklist and property recovery process.",
    processControlDesign: "manual",
    typeOfProcessControl: "Detective",
    processControlCategory: "Operational",
    frequency: "Per termination",
    processControlOwner: "HR Manager",
    expectedDeviations: ["Unreturned assets", "Process gaps"],
    auditTestingProcedures: ["Review exit checklists", "Conduct asset audits"]
  },
  {
    industry: "Common",
    department: "HR",
    riskId: "HR-TER-007",
    riskDescription: "Inadequate communication of termination decisions affecting team morale - Issue 7",
    riskCause: ["Poor communication strategy", "Lack of sensitivity training"],
    consequence: "Decreased morale and potential internal conflicts.",
    riskCategory: "Operational",
    processControlId: "CTRL-TER-007",
    processControlDescription: "Develop a clear communication protocol for terminations.",
    processControlDesign: "manual",
    typeOfProcessControl: "Preventive",
    processControlCategory: "Operational",
    frequency: "Per termination",
    processControlOwner: "HR Manager",
    expectedDeviations: ["Miscommunication", "Low employee engagement"],
    auditTestingProcedures: ["Survey team feedback", "Review communication logs"]
  },
  {
    industry: "Common",
    department: "HR",
    riskId: "HR-TER-008",
    riskDescription: "Improper handling of terminations causing reputational damage - Issue 8",
    riskCause: ["Insensitive exit procedures", "Lack of follow-up support"],
    consequence: "Damage to employer brand and potential legal exposure.",
    riskCategory: "Strategic",
    processControlId: "CTRL-TER-008",
    processControlDescription: "Standardize respectful termination and offboarding protocols.",
    processControlDesign: "manual",
    typeOfProcessControl: "Preventive",
    processControlCategory: "Strategic",
    frequency: "Per termination",
    processControlOwner: "HR Manager",
    expectedDeviations: ["Negative exit experiences", "Reputational risk"],
    auditTestingProcedures: ["Review exit interviews", "Assess offboarding satisfaction"]
  },
  {
    industry: "Common",
    department: "HR",
    riskId: "HR-TER-009",
    riskDescription: "Legal non-compliance in termination procedures exposing the company to lawsuits - Issue 9",
    riskCause: ["Outdated policies", "Lack of legal oversight"],
    consequence: "Increased litigation costs and regulatory penalties.",
    riskCategory: "Compliance",
    processControlId: "CTRL-TER-009",
    processControlDescription: "Regularly update termination policies in line with legal standards.",
    processControlDesign: "system dependent",
    typeOfProcessControl: "Preventive",
    processControlCategory: "Compliance",
    frequency: "Annually",
    processControlOwner: "Legal Department",
    expectedDeviations: ["Non-compliance findings", "Policy gaps"],
    auditTestingProcedures: ["Review policy updates", "Conduct legal audits"]
  },
  {
    industry: "Common",
    department: "HR",
    riskId: "HR-TER-010",
    riskDescription: "Inefficient processing of final settlements causing payment delays - Issue 10",
    riskCause: ["Manual processing", "Lack of standardized procedures"],
    consequence: "Delayed final payments leading to employee dissatisfaction and potential disputes.",
    riskCategory: "Financial",
    processControlId: "CTRL-TER-010",
    processControlDescription: "Automate final settlement calculations and standardize procedures.",
    processControlDesign: "automated",
    typeOfProcessControl: "Detective",
    processControlCategory: "Financial",
    frequency: "Per termination",
    processControlOwner: "Payroll Manager",
    expectedDeviations: ["Settlement delays", "Calculation errors"],
    auditTestingProcedures: ["Review settlement records", "Test automation accuracy"]
  }
];

// Onboarding Risks (10 records)
const onboardingRiskData = [
  {
    industry: "Common",
    department: "HR",
    riskId: "HR-ONB-001",
    riskDescription: "Ineffective onboarding causing low employee engagement - Issue 1",
    riskCause: ["Lack of structured orientation", "Poor welcome communication"],
    consequence: "New hires feel disconnected, affecting early productivity.",
    riskCategory: "Operational",
    processControlId: "CTRL-ONB-001",
    processControlDescription: "Develop a comprehensive onboarding program with clear timelines.",
    processControlDesign: "manual",
    typeOfProcessControl: "Preventive",
    processControlCategory: "Operational",
    frequency: "Per onboarding",
    processControlOwner: "HR Manager",
    expectedDeviations: ["Low engagement", "Incomplete orientation"],
    auditTestingProcedures: ["Review onboarding feedback", "Monitor early performance"]
  },
  {
    industry: "Common",
    department: "HR",
    riskId: "HR-ONB-002",
    riskDescription: "Delayed onboarding process impacting new hire productivity - Issue 2",
    riskCause: ["Inefficient scheduling", "Poor coordination with IT and facilities"],
    consequence: "New employees experience downtime before becoming effective.",
    riskCategory: "Operational",
    processControlId: "CTRL-ONB-002",
    processControlDescription: "Coordinate onboarding schedules across departments for timely access.",
    processControlDesign: "automated",
    typeOfProcessControl: "Preventive",
    processControlCategory: "Operational",
    frequency: "Per onboarding",
    processControlOwner: "HR Manager",
    expectedDeviations: ["Delayed start dates", "Access issues"],
    auditTestingProcedures: ["Review onboarding schedules", "Audit access setup"]
  },
  {
    industry: "Common",
    department: "HR",
    riskId: "HR-ONB-003",
    riskDescription: "Insufficient training during onboarding leading to skill gaps - Issue 3",
    riskCause: ["Limited orientation sessions", "Outdated training materials"],
    consequence: "New hires lack necessary skills to perform effectively.",
    riskCategory: "Operational",
    processControlId: "CTRL-ONB-003",
    processControlDescription: "Update training modules and incorporate hands-on learning in onboarding.",
    processControlDesign: "manual",
    typeOfProcessControl: "Preventive",
    processControlCategory: "Operational",
    frequency: "Per onboarding",
    processControlOwner: "HR Manager",
    expectedDeviations: ["Skill gaps", "Low training retention"],
    auditTestingProcedures: ["Evaluate training assessments", "Survey new hire competence"]
  },
  {
    industry: "Common",
    department: "HR",
    riskId: "HR-ONB-004",
    riskDescription: "Poor integration with team and culture affecting retention - Issue 4",
    riskCause: ["Lack of socialization activities", "Insufficient mentoring"],
    consequence: "New hires leave early, increasing turnover rates.",
    riskCategory: "Operational",
    processControlId: "CTRL-ONB-004",
    processControlDescription: "Implement buddy systems and structured cultural orientation.",
    processControlDesign: "manual",
    typeOfProcessControl: "Preventive",
    processControlCategory: "Operational",
    frequency: "Per onboarding",
    processControlOwner: "HR Manager",
    expectedDeviations: ["Low retention", "Poor cultural fit"],
    auditTestingProcedures: ["Review exit interviews", "Monitor retention rates"]
  },
  {
    industry: "Common",
    department: "HR",
    riskId: "HR-ONB-005",
    riskDescription: "Lack of clear onboarding documentation causing confusion - Issue 5",
    riskCause: ["Incomplete onboarding manuals", "Unstandardized procedures"],
    consequence: "New hires struggle to understand roles and expectations.",
    riskCategory: "Operational",
    processControlId: "CTRL-ONB-005",
    processControlDescription: "Develop and distribute a standardized onboarding handbook.",
    processControlDesign: "manual",
    typeOfProcessControl: "Preventive",
    processControlCategory: "Operational",
    frequency: "Per onboarding",
    processControlOwner: "HR Manager",
    expectedDeviations: ["Confusing documentation", "Misaligned expectations"],
    auditTestingProcedures: ["Review handbook updates", "Survey new hire clarity"]
  },
  {
    industry: "Common",
    department: "HR",
    riskId: "HR-ONB-006",
    riskDescription: "Inadequate IT setup delaying access to necessary tools - Issue 6",
    riskCause: ["Poor coordination with IT", "Outdated system provisioning"],
    consequence: "New hires cannot perform tasks due to lack of system access.",
    riskCategory: "Operational",
    processControlId: "CTRL-ONB-006",
    processControlDescription: "Coordinate with IT to ensure all access is ready before onboarding starts.",
    processControlDesign: "automated",
    typeOfProcessControl: "Preventive",
    processControlCategory: "Operational",
    frequency: "Per onboarding",
    processControlOwner: "IT Manager",
    expectedDeviations: ["Delayed system access", "Access errors"],
    auditTestingProcedures: ["Review IT provisioning logs", "Test access readiness"]
  },
  {
    industry: "Common",
    department: "HR",
    riskId: "HR-ONB-007",
    riskDescription: "Failure to assign a mentor during onboarding affecting acclimation - Issue 7",
    riskCause: ["Lack of mentoring program", "Overburdened senior staff"],
    consequence: "New hires struggle to integrate, reducing productivity.",
    riskCategory: "Operational",
    processControlId: "CTRL-ONB-007",
    processControlDescription: "Establish a formal mentoring program for new hires.",
    processControlDesign: "manual",
    typeOfProcessControl: "Preventive",
    processControlCategory: "Operational",
    frequency: "Per onboarding",
    processControlOwner: "HR Manager",
    expectedDeviations: ["No assigned mentor", "Poor mentoring quality"],
    auditTestingProcedures: ["Review mentor assignment records", "Survey mentee satisfaction"]
  },
  {
    industry: "Common",
    department: "HR",
    riskId: "HR-ONB-008",
    riskDescription: "Incomplete onboarding process leading to compliance issues - Issue 8",
    riskCause: ["Omitted compliance training", "Unclear policy communication"],
    consequence: "New hires fail to meet regulatory requirements.",
    riskCategory: "Compliance",
    processControlId: "CTRL-ONB-008",
    processControlDescription: "Include mandatory compliance modules in onboarding and verify completion.",
    processControlDesign: "automated",
    typeOfProcessControl: "Preventive",
    processControlCategory: "Compliance",
    frequency: "Per onboarding",
    processControlOwner: "HR Manager",
    expectedDeviations: ["Missed compliance training", "Unaware employees"],
    auditTestingProcedures: ["Review training completion records", "Test policy awareness"]
  },
  {
    industry: "Common",
    department: "HR",
    riskId: "HR-ONB-009",
    riskDescription: "Insufficient orientation on company policies causing operational risks - Issue 9",
    riskCause: ["Brief orientation sessions", "Overloaded information"],
    consequence: "New hires misunderstand critical policies leading to errors.",
    riskCategory: "Operational",
    processControlId: "CTRL-ONB-009",
    processControlDescription: "Enhance orientation sessions with interactive policy training.",
    processControlDesign: "manual",
    typeOfProcessControl: "Detective",
    processControlCategory: "Operational",
    frequency: "Per onboarding",
    processControlOwner: "HR Manager",
    expectedDeviations: ["Policy misunderstandings", "Non-compliance incidents"],
    auditTestingProcedures: ["Assess new hire policy knowledge", "Review orientation materials"]
  },
  {
    industry: "Common",
    department: "HR",
    riskId: "HR-ONB-010",
    riskDescription: "Inefficient onboarding feedback mechanism missing improvement areas - Issue 10",
    riskCause: ["Lack of structured feedback", "No follow-up surveys"],
    consequence: "Missed opportunities to improve the onboarding process.",
    riskCategory: "Operational",
    processControlId: "CTRL-ONB-010",
    processControlDescription: "Establish a structured onboarding feedback process and review results regularly.",
    processControlDesign: "manual",
    typeOfProcessControl: "Detective",
    processControlCategory: "Operational",
    frequency: "Per onboarding",
    processControlOwner: "HR Manager",
    expectedDeviations: ["Lack of feedback", "No process improvements"],
    auditTestingProcedures: ["Review feedback submissions", "Analyze improvement actions"]
  }
];

// Training Risks (10 records)
const trainingRiskData = [
  {
    industry: "Common",
    department: "HR",
    riskId: "HR-TRN-001",
    riskDescription: "Outdated training materials leading to skill mismatches - Issue 1",
    riskCause: ["Old content", "Lack of periodic updates"],
    consequence: "Employees develop skills that do not meet current job requirements.",
    riskCategory: "Operational",
    processControlId: "CTRL-TRN-001",
    processControlDescription: "Regularly update training materials and incorporate current industry practices.",
    processControlDesign: "manual",
    typeOfProcessControl: "Preventive",
    processControlCategory: "Operational",
    frequency: "Annually",
    processControlOwner: "Training Manager",
    expectedDeviations: ["Outdated content", "Irrelevant training"],
    auditTestingProcedures: ["Review training content updates", "Survey trainee satisfaction"]
  },
  {
    industry: "Common",
    department: "HR",
    riskId: "HR-TRN-002",
    riskDescription: "Ineffective training delivery causing low knowledge retention - Issue 2",
    riskCause: ["Poor instructional methods", "Unengaging content"],
    consequence: "Low application of learned skills and decreased productivity.",
    riskCategory: "Operational",
    processControlId: "CTRL-TRN-002",
    processControlDescription: "Adopt interactive and engaging training delivery methods.",
    processControlDesign: "system dependent",
    typeOfProcessControl: "Preventive",
    processControlCategory: "Operational",
    frequency: "Per training session",
    processControlOwner: "Training Manager",
    expectedDeviations: ["Low retention rates", "High drop-off rates"],
    auditTestingProcedures: ["Conduct post-training assessments", "Review feedback forms"]
  },
  {
    industry: "Common",
    department: "HR",
    riskId: "HR-TRN-003",
    riskDescription: "Insufficient training hours leading to inadequate skill development - Issue 3",
    riskCause: ["Compressed training schedules", "Overloaded agendas"],
    consequence: "Employees do not gain sufficient expertise for their roles.",
    riskCategory: "Operational",
    processControlId: "CTRL-TRN-003",
    processControlDescription: "Ensure adequate training duration and proper scheduling.",
    processControlDesign: "manual",
    typeOfProcessControl: "Preventive",
    processControlCategory: "Operational",
    frequency: "Per training cycle",
    processControlOwner: "Training Manager",
    expectedDeviations: ["Insufficient training time", "Overlapping sessions"],
    auditTestingProcedures: ["Review training schedules", "Assess competency levels post-training"]
  },
  {
    industry: "Common",
    department: "HR",
    riskId: "HR-TRN-004",
    riskDescription: "Lack of practical training components reducing effectiveness - Issue 4",
    riskCause: ["Theory-heavy curriculum", "No hands-on exercises"],
    consequence: "Employees fail to apply concepts in real work scenarios.",
    riskCategory: "Operational",
    processControlId: "CTRL-TRN-004",
    processControlDescription: "Integrate practical exercises and simulations into training programs.",
    processControlDesign: "manual",
    typeOfProcessControl: "Preventive",
    processControlCategory: "Operational",
    frequency: "Per training session",
    processControlOwner: "Training Manager",
    expectedDeviations: ["Low practical application", "High error rates"],
    auditTestingProcedures: ["Observe training sessions", "Review practical test results"]
  },
  {
    industry: "Common",
    department: "HR",
    riskId: "HR-TRN-005",
    riskDescription: "Inconsistent training delivery across departments affecting overall performance - Issue 5",
    riskCause: ["Varying trainer quality", "Lack of standardization"],
    consequence: "Uneven skill levels and operational inefficiencies.",
    riskCategory: "Operational",
    processControlId: "CTRL-TRN-005",
    processControlDescription: "Standardize training modules and conduct trainer evaluations.",
    processControlDesign: "manual",
    typeOfProcessControl: "Detective",
    processControlCategory: "Operational",
    frequency: "Annually",
    processControlOwner: "Training Manager",
    expectedDeviations: ["Inconsistent delivery", "Trainer performance issues"],
    auditTestingProcedures: ["Review training consistency", "Conduct trainer assessments"]
  },
  {
    industry: "Common",
    department: "HR",
    riskId: "HR-TRN-006",
    riskDescription: "Poor training feedback mechanisms leading to unaddressed issues - Issue 6",
    riskCause: ["Lack of feedback forms", "No follow-up on suggestions"],
    consequence: "Training programs remain ineffective over time.",
    riskCategory: "Operational",
    processControlId: "CTRL-TRN-006",
    processControlDescription: "Establish structured feedback collection and review process after training.",
    processControlDesign: "manual",
    typeOfProcessControl: "Detective",
    processControlCategory: "Operational",
    frequency: "Per training session",
    processControlOwner: "Training Manager",
    expectedDeviations: ["Low feedback response", "Unaddressed issues"],
    auditTestingProcedures: ["Review feedback summaries", "Assess training improvements"]
  },
  {
    industry: "Common",
    department: "HR",
    riskId: "HR-TRN-007",
    riskDescription: "High training costs without measurable ROI - Issue 7",
    riskCause: ["Inefficient training programs", "Lack of performance metrics"],
    consequence: "Overspending on training with little improvement in employee performance.",
    riskCategory: "Financial",
    processControlId: "CTRL-TRN-007",
    processControlDescription: "Implement performance tracking and cost-benefit analysis for training programs.",
    processControlDesign: "automated",
    typeOfProcessControl: "Detective",
    processControlCategory: "Financial",
    frequency: "Annually",
    processControlOwner: "Training Manager",
    expectedDeviations: ["High costs", "Low performance gains"],
    auditTestingProcedures: ["Analyze training ROI", "Review performance metrics"]
  },
  {
    industry: "Common",
    department: "HR",
    riskId: "HR-TRN-008",
    riskDescription: "Failure to update training based on evolving job roles - Issue 8",
    riskCause: ["Static curriculum", "Lack of industry benchmarking"],
    consequence: "Employees fall behind current best practices, reducing competitiveness.",
    riskCategory: "Operational",
    processControlId: "CTRL-TRN-008",
    processControlDescription: "Regularly review and update training content with industry trends.",
    processControlDesign: "system dependent",
    typeOfProcessControl: "Preventive",
    processControlCategory: "Operational",
    frequency: "Annually",
    processControlOwner: "Training Manager",
    expectedDeviations: ["Outdated training", "Skill gaps"],
    auditTestingProcedures: ["Review content update logs", "Benchmark training programs"]
  },
  {
    industry: "Common",
    department: "HR",
    riskId: "HR-TRN-009",
    riskDescription: "Limited access to training resources causing skill gaps - Issue 9",
    riskCause: ["Budget constraints", "Inadequate resource allocation"],
    consequence: "Employees lack the tools needed for professional development.",
    riskCategory: "Operational",
    processControlId: "CTRL-TRN-009",
    processControlDescription: "Increase investment in training resources and ensure equal access.",
    processControlDesign: "manual",
    typeOfProcessControl: "Preventive",
    processControlCategory: "Operational",
    frequency: "Annually",
    processControlOwner: "Training Manager",
    expectedDeviations: ["Resource shortages", "Unequal access"],
    auditTestingProcedures: ["Review resource allocation", "Survey employee access"]
  },
  {
    industry: "Common",
    department: "HR",
    riskId: "HR-TRN-010",
    riskDescription: "Inadequate tracking of training progress affecting performance reviews - Issue 10",
    riskCause: ["Lack of proper training management systems", "Manual record-keeping"],
    consequence: "Difficulties in assessing employee development and performance.",
    riskCategory: "Operational",
    processControlId: "CTRL-TRN-010",
    processControlDescription: "Implement a training management system that tracks progress automatically.",
    processControlDesign: "automated",
    typeOfProcessControl: "Detective",
    processControlCategory: "Operational",
    frequency: "Per training cycle",
    processControlOwner: "Training Manager",
    expectedDeviations: ["Incomplete records", "Poor performance tracking"],
    auditTestingProcedures: ["Audit training records", "Review performance review data"]
  }
];

// Manpower Planning Risks (10 records)
const manpowerPlanningRiskData = [
  {
    industry: "Common",
    department: "HR",
    riskId: "HR-MP-001",
    riskDescription: "Inaccurate workforce forecasting leading to talent shortages - Issue 1",
    riskCause: ["Outdated forecasting models", "Insufficient market data"],
    consequence: "Understaffing in critical areas, affecting business operations.",
    riskCategory: "Operational",
    processControlId: "CTRL-MP-001",
    processControlDescription: "Adopt advanced HR analytics for accurate workforce forecasting.",
    processControlDesign: "automated",
    typeOfProcessControl: "Preventive",
    processControlCategory: "Operational",
    frequency: "Quarterly",
    processControlOwner: "HR Manager",
    expectedDeviations: ["Forecast inaccuracies", "Talent shortages"],
    auditTestingProcedures: ["Review forecasting reports", "Compare forecast vs. actual staffing"]
  },
  {
    industry: "Common",
    department: "HR",
    riskId: "HR-MP-002",
    riskDescription: "Overestimation of manpower needs resulting in excess staffing - Issue 2",
    riskCause: ["Overly optimistic models", "Lack of historical data analysis"],
    consequence: "Increased labor costs and inefficiencies.",
    riskCategory: "Financial",
    processControlId: "CTRL-MP-002",
    processControlDescription: "Refine forecasting models with historical data and market trends.",
    processControlDesign: "system dependent",
    typeOfProcessControl: "Preventive",
    processControlCategory: "Financial",
    frequency: "Quarterly",
    processControlOwner: "HR Manager",
    expectedDeviations: ["Excess headcount", "Increased payroll costs"],
    auditTestingProcedures: ["Analyze staffing ratios", "Review forecast accuracy"]
  },
  {
    industry: "Common",
    department: "HR",
    riskId: "HR-MP-003",
    riskDescription: "Failure to align manpower planning with business strategy - Issue 3",
    riskCause: ["Lack of strategic integration", "Poor communication between departments"],
    consequence: "Misalignment of talent supply with business needs.",
    riskCategory: "Strategic",
    processControlId: "CTRL-MP-003",
    processControlDescription: "Integrate manpower planning with overall business strategy sessions.",
    processControlDesign: "manual",
    typeOfProcessControl: "Preventive",
    processControlCategory: "Strategic",
    frequency: "Annually",
    processControlOwner: "HR Director",
    expectedDeviations: ["Strategic misalignment", "Talent gaps"],
    auditTestingProcedures: ["Review strategic planning documents", "Assess alignment metrics"]
  },
  {
    industry: "Common",
    department: "HR",
    riskId: "HR-MP-004",
    riskDescription: "Inefficient use of data causing unreliable workforce analysis - Issue 4",
    riskCause: ["Fragmented HR systems", "Lack of integrated data"],
    consequence: "Poor decision making due to inaccurate workforce insights.",
    riskCategory: "Operational",
    processControlId: "CTRL-MP-004",
    processControlDescription: "Implement an integrated HR information system for real-time data analysis.",
    processControlDesign: "automated",
    typeOfProcessControl: "Preventive",
    processControlCategory: "Operational",
    frequency: "Monthly",
    processControlOwner: "HR Manager",
    expectedDeviations: ["Data discrepancies", "Inefficient reporting"],
    auditTestingProcedures: ["Audit HRIS data", "Review analytics reports"]
  },
  {
    industry: "Common",
    department: "HR",
    riskId: "HR-MP-005",
    riskDescription: "Lack of contingency planning for turnover affecting continuity - Issue 5",
    riskCause: ["No backup plans", "Inadequate succession planning"],
    consequence: "Operational disruptions when key positions become vacant unexpectedly.",
    riskCategory: "Operational",
    processControlId: "CTRL-MP-005",
    processControlDescription: "Develop and maintain robust succession and contingency plans.",
    processControlDesign: "manual",
    typeOfProcessControl: "Preventive",
    processControlCategory: "Operational",
    frequency: "Annually",
    processControlOwner: "HR Manager",
    expectedDeviations: ["Turnover spikes", "Lack of replacements"],
    auditTestingProcedures: ["Review succession plans", "Conduct scenario planning exercises"]
  },
  {
    industry: "Common",
    department: "HR",
    riskId: "HR-MP-006",
    riskDescription: "Delayed manpower planning resulting in recruitment bottlenecks - Issue 6",
    riskCause: ["Slow data processing", "Poor coordination with business units"],
    consequence: "Delayed recruitment and missed project deadlines.",
    riskCategory: "Operational",
    processControlId: "CTRL-MP-006",
    processControlDescription: "Establish regular manpower planning reviews and cross-department coordination.",
    processControlDesign: "manual",
    typeOfProcessControl: "Detective",
    processControlCategory: "Operational",
    frequency: "Quarterly",
    processControlOwner: "HR Manager",
    expectedDeviations: ["Planning delays", "Recruitment lags"],
    auditTestingProcedures: ["Review planning meeting minutes", "Analyze recruitment timelines"]
  },
  {
    industry: "Common",
    department: "HR",
    riskId: "HR-MP-007",
    riskDescription: "Poor integration of HR analytics with planning processes - Issue 7",
    riskCause: ["Lack of analytic tools", "Data silos"],
    consequence: "Ineffective manpower planning and misinformed decisions.",
    riskCategory: "Operational",
    processControlId: "CTRL-MP-007",
    processControlDescription: "Integrate HR analytics tools with planning processes for real-time insights.",
    processControlDesign: "automated",
    typeOfProcessControl: "Preventive",
    processControlCategory: "Operational",
    frequency: "Monthly",
    processControlOwner: "HR Manager",
    expectedDeviations: ["Data integration issues", "Poor insights"],
    auditTestingProcedures: ["Review analytics integration", "Test reporting accuracy"]
  },
  {
    industry: "Common",
    department: "HR",
    riskId: "HR-MP-008",
    riskDescription: "Inadequate succession planning causing leadership gaps - Issue 8",
    riskCause: ["Failure to identify potential leaders", "Lack of development programs"],
    consequence: "Leadership vacuum affecting strategic continuity.",
    riskCategory: "Strategic",
    processControlId: "CTRL-MP-008",
    processControlDescription: "Implement a formal succession planning process with leadership development.",
    processControlDesign: "manual",
    typeOfProcessControl: "Preventive",
    processControlCategory: "Strategic",
    frequency: "Annually",
    processControlOwner: "HR Director",
    expectedDeviations: ["Leadership gaps", "Delayed promotions"],
    auditTestingProcedures: ["Review succession planning documents", "Assess leadership pipelines"]
  },
  {
    industry: "Common",
    department: "HR",
    riskId: "HR-MP-009",
    riskDescription: "Failure to adapt to market changes leading to misaligned talent supply - Issue 9",
    riskCause: ["Rigid planning processes", "Ignoring market trends"],
    consequence: "Inability to meet evolving business needs and talent shortages.",
    riskCategory: "Strategic",
    processControlId: "CTRL-MP-009",
    processControlDescription: "Regularly review market trends and adjust manpower plans accordingly.",
    processControlDesign: "system dependent",
    typeOfProcessControl: "Preventive",
    processControlCategory: "Strategic",
    frequency: "Quarterly",
    processControlOwner: "HR Manager",
    expectedDeviations: ["Talent misalignment", "Inflexible planning"],
    auditTestingProcedures: ["Compare planned vs. actual staffing", "Review market trend reports"]
  },
  {
    industry: "Common",
    department: "HR",
    riskId: "HR-MP-010",
    riskDescription: "Insufficient scenario planning resulting in reactive staffing decisions - Issue 10",
    riskCause: ["Lack of contingency analysis", "Reactive planning culture"],
    consequence: "Last-minute hiring and increased recruitment costs during crises.",
    riskCategory: "Operational",
    processControlId: "CTRL-MP-010",
    processControlDescription: "Develop scenario-based manpower planning to anticipate future staffing needs.",
    processControlDesign: "manual",
    typeOfProcessControl: "Detective",
    processControlCategory: "Operational",
    frequency: "Annually",
    processControlOwner: "HR Manager",
    expectedDeviations: ["Reactive hiring", "Cost spikes"],
    auditTestingProcedures: ["Review scenario plans", "Assess staffing responsiveness"]
  }
];

const commonHRRiskData = [
  ...hiringRiskData,
  ...terminationRiskData,
  ...onboardingRiskData,
  ...trainingRiskData,
  ...manpowerPlanningRiskData
];

export default commonHRRiskData;
